<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-comments"></i></div>
      <div>
        Préoccupations
        <div class="page-title-subheading">Demandes et signalements des utilisateurs</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>
   <div class="row">
    <div class="col-lg-12">
        <div class="card">
          
            <div class="card-body">
                  <div class="d-flex justify-content-between mb-5">
                    <div class="me-2">
                        <button *ngIf="buttonsPermission?.add" type="button" class="btn btn-danger btn-sm" (click)="add(addContent)">
                            <i class="fa-solid fa-plus me-2" aria-hidden="true"></i>Nouvelle préoccupation
                            </button>
                    </div>
                    <div class=" " *ngIf="buttonsPermission">
                        <button *ngIf="type=='own'" class="btn btn-info btn-sm btn-label waves-effect waves-light  me-3" (click)="add(addContent)">Enregistrer une requête</button>
                        <button *ngIf="selected_data && buttonsPermission.show"  (click)="show(showContent)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                             <span>Consulter</span></button>
                        <button *ngIf="selected_data?.user_id==user?.id && buttonsPermission.edit && selected_data?.status==0" (click)="edit(editContent)" type="button"  class="btn btn-outline-warning btn-sm btn-label waves-effect waves-light me-3">
                           Editer</button>
                        <button *ngIf="selected_data?.user_id==user?.id && buttonsPermission.delete && selected_data?.status==0" (click)="delete()" type="button" class="btn btn-outline-danger btn-sm btn-label waves-effect waves-light me-3">
                             Supprimer</button>
                             <button *ngIf="selected_data!=undefined && selected_data.status==0" (click)="setStatus(1)" type="button" class="btn btn-outline-primary btn-sm btn-label waves-effect waves-light me-3">
                                Soumettre ma préoccupation</button>
                    </div>

                  
                
                    <div class="form-group ms-auto">
                        <label for="search_text" class="form-label mb-0"><strong>Rechercher</strong></label>
                        <input id="search_text" type="text" name="search_text" class="form-control form-control-sm"
                               placeholder="Rechercher..." [(ngModel)]="search_text">
                    </div>
                </div>

                        <p>{{data!.length}} élément(s)</p>
                        <div class="table-responsive">
                        <table class="table" >
                            <thead class="">
                                <tr>
                                    <th style="width: 10px;">#</th>
                                    <th>Objet</th>
                                    <th>Contenu</th>
                                    <th>PJ</th>
                                    <th>Statut</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr (click)="checked(d)" [class.table-active]="selected_data?.id === d.id" style="cursor: pointer;" *ngFor="let d of data | sampleSearch:search_text:'courses' | paginate: {
                                id:'ngxP1',
                                itemsPerPage: pg.pageSize,
                                currentPage: pg.p,
                                totalItems: pg.total } ">
                                    <td>
                                        <div class="form-check mb-2">
                                            <input (click)="checked(d)" class="form-check-input" type="radio" [checked]="selected_data?.id === d.id" name="flexRadioDefault">
                                        
                                        </div>
                                    </td>
                                    <td>{{d.object}}</td>
                                    <td>
                                        <div [innerHTML]="d.content"></div>
                                    </td>
                                    <td >
                                        <button *ngIf="d.filename" class="btn btn-sm btn-outline-primary" (click)="getFile(d.code,'',d.filename)">Ouvrir</button>
                                    </td>
                                   
                                    <td>
                                        <span *ngIf="d.status==0" class="badge bg-secondary">Nouvelle préoccupation</span>
                                        <span *ngIf="d.status==1" class="badge bg-warning">En attente de traitement</span>
                                        <span *ngIf="d.status==2" class="badge bg-info">EN cours de traitement</span>
                                        <span *ngIf="d.status==4" class="badge bg-success">Traité</span>

                                    </td>
                                </tr>
                            
                            </tbody>
                        </table>
                        </div>
                          <pagination-controls 
                        id="ngxP1"
                        (pageChange)="getPage($event)"
                      [maxSize]="9"
                      [directionLinks]="true"
                      [autoHide]="true"
                      [responsive]="true"
                      [previousLabel]="'Précédent'"
                      [nextLabel]="'Suivant'"
                      [screenReaderPaginationLabel]="'Pagination'"
                      [screenReaderPageLabel]="'page'"
                      [screenReaderCurrentLabel]="'Vous êtes sur la page'">
                     </pagination-controls>

            </div><!-- end card -->
        </div>
        <!-- end col -->
    </div>
    <!-- end col -->
</div>


<ng-template #addContent let-c="close" let-d="dismiss">
    <form #addForm="ngForm" (ngSubmit)="store(addForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Enregistrer une matière</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3" >
      
            <div class=" form-group col-12 mb-3">
                <label for="">Objet <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="object" class="form-control" ngModel required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Message <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="content" [placeholder]="'Saisir votre préoccupation'" ngModel required></angular-editor>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">PJ</label>
                <input type="file" class="form-control" ngModel (change)="upload($event)" >
            </div>

        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="addForm.invalid"  >Enregistrer <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #editContent let-c="close" let-d="dismiss">
    <form #editForm="ngForm" (ngSubmit)="update(editForm.value)">
    <div class="modal-header">
      <h6 class="modal-title" id="modal-basic-title">Modifier une matière</h6>
      <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
    </div>
    <div class="modal-body" >
        <div class="row mb-3">
            <div class=" form-group col-12 mb-3">
                <label for="">Objet <span class="text-danger ml-2">(*)</span></label>
                <input type="text" name="object" class="form-control" [(ngModel)]="selected_data.object" required>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">Message <span class="text-danger ml-2">(*)</span></label>
                <angular-editor name="content" [placeholder]="'Saisir votre préoccupation'" [(ngModel)]="selected_data.content" required></angular-editor>
            </div>
            <div class=" form-group col-12 mb-3">
                <label for="">PJ</label>
                <input type="file" class="form-control" ngModel (change)="upload($event)" >
            </div>

           
        </div>
       
    </div>
    <div class="modal-footer">
      <button type="submit" class="btn btn-outline-dark" [disabled]="editForm.invalid" >Sauvegarder <app-loading [isVisible]="loading"></app-loading></button>
    </div>
</form>
  </ng-template>

  <ng-template #showContent let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">Détails des informations</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')"></button>
      </div>

      <div class="modal-body">
        <div class="table-responsive table-card">
            <table class="table table-borderless align-middle mb-0">
                <tbody>
                 
                </tbody>
            </table>
        </div>
      </div>
</ng-template>

<ng-template #contentPDF let-offcanvas>
	<div class="offcanvas-header">
    
		<h4 class="offcanvas-title">Visualiseur de fichier</h4>
		<button id="closePDFBtn" type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss('Cross click')"></button>
	</div>
	<div class="offcanvas-body">
        <ngx-extended-pdf-viewer [src]="pdfSrc"
        style="width: 100%; height: 100%"
        ></ngx-extended-pdf-viewer>
	</div>
</ng-template>
